import { useEffect, useState } from "react";
import { motion } from "framer-motion";

const links = [
  { label: "BRIEFING", href: "#about" },
  { label: "TRANSMISSION", href: "#content" },
  { label: "ENLIST", href: "#enlist" },
];

export default function Nav() {
  const [scrolled, setScrolled] = useState(false);
  const [time, setTime] = useState("");

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    const tick = () =>
      setTime(
        new Date().toLocaleTimeString("en-GB", { hour12: false }) + " UTC"
      );
    tick();
    const t = setInterval(tick, 1000);
    return () => {
      window.removeEventListener("scroll", onScroll);
      clearInterval(t);
    };
  }, []);

  const jump = (e, href) => {
    e.preventDefault();
    document.querySelector(href)?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <motion.nav
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.8, delay: 0.2, ease: [0.16, 1, 0.3, 1] }}
      className={`fixed inset-x-0 top-0 z-50 transition-colors duration-300 ${
        scrolled ? "bg-bunker-shadow/80 backdrop-blur-md border-b border-white/10" : "bg-transparent"
      }`}
      data-testid="main-nav"
    >
      <div className="mx-auto flex max-w-[1600px] items-center justify-between px-6 py-4 md:px-10">
        <a
          href="#top"
          onClick={(e) => jump(e, "#top")}
          className="flex items-center gap-3"
          data-testid="nav-logo"
        >
          <span className="h-2.5 w-2.5 animate-pulse bg-reactor-red text-glow-red" />
          <span className="font-mono text-sm tracking-[0.4em] text-white">THINKAVARIUM</span>
        </a>

        <div className="hidden items-center gap-6 md:flex">
          {links.map((l, i) => (
            <div key={l.href} className="flex items-center gap-6">
              {i > 0 && (
                <span
                  aria-hidden="true"
                  className="h-4 w-px bg-white/20"
                  data-testid="nav-divider"
                />
              )}
              <a
                href={l.href}
                onClick={(e) => jump(e, l.href)}
                className="font-mono text-xs font-bold tracking-[0.3em] text-white/60 transition-colors duration-100 hover:text-hazard-amber md:text-[17.25px]"
                data-testid={`nav-${l.label.toLowerCase()}`}
              >
                {l.label}
              </a>
            </div>
          ))}
        </div>

        <div className="hidden items-center gap-3 font-mono text-xs tracking-widest text-tactical-green md:flex md:text-[15px]">
          <span className="h-1.5 w-1.5 animate-pulse bg-tactical-green" />
          {time}
        </div>
      </div>
    </motion.nav>
  );
}
